// extracted by mini-css-extract-plugin
export default {"root":"ProductType_root__A7p-c"};